import { Slide } from "@mui/material";
import { TransitionProps } from "@mui/material/transitions";
import React from "react";

export const SlideTransition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<unknown>;
  },
  ref: React.Ref<unknown>,
  direction: "left" | "right" | "up" | "down" | undefined = "left"
) {
  return <Slide direction={direction} ref={ref} {...props} />;
});
